const initialState = {
  messages: {},
  unProcessedMessages: {},
  messageToSend: undefined,
  focusLatLng: undefined,
};

const getSelectedPageMessages = (
  state: MessageState,
  action: any
): MessageState => {
  const updatedMessages = state.messages;
  const { pageId } = action.payload;
  const flag = action.payload.refMessage?.referenceType;
  const originalPageMessageId = action.payload?.originalPageMessageId;
  const unProcessedMessages = state.unProcessedMessages;

  if (updatedMessages[pageId]) {
    if (flag === "update") {
      let index = updatedMessages[pageId].findIndex((x: MessageInfo) => {
        return (
          x.id === originalPageMessageId ||
          x.originalPageMessageId === originalPageMessageId
        );
      });
      updatedMessages[pageId][index] = action.payload;
    } else if (flag === "remove") {
      let index = updatedMessages[pageId].findIndex((x: MessageInfo) => {
        return (
          x.id === originalPageMessageId ||
          x.originalPageMessageId === originalPageMessageId
        );
      });
      updatedMessages[pageId].splice(index, 1);
    } else updatedMessages[pageId].push(action.payload);
  } else {
    updatedMessages[pageId] = [action.payload];
  }

  unProcessedMessages?.[pageId]?.push(action.payload);
  return {
    ...state,
    messages: updatedMessages,
    currentMessage: action.payload,
    unProcessedMessages: unProcessedMessages,
  };
};

const deleteMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId, messageId } = action.payload;

  let index = messages[pageId].findIndex((x: MessageInfo) => {
    return x.id === messageId;
  });
  messages[pageId].splice(index, 1);

  return {
    ...state,
    messages: messages,
  };
};

const updateMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId, messageId, changes } = action.payload;

  let index = messages[pageId].findIndex((x: MessageInfo) => {
    return x.id === messageId;
  });
  messages[pageId][index].message = changes[0].value;

  return {
    ...state,
    messages: messages,
  };
};

const clearMessage = (state: MessageState, action: any): MessageState => {
  let messages = state.messages;
  const { pageId } = action.payload;
  messages[pageId] = [];
  return {
    ...state,
    messages: messages,
  };
};

const getMessageToSend = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageToSend: action.payload,
  };
};

// Changing the sort invalidates everything already fetched, so pagination
// resets with it — otherwise the top of the list is re-ordered while the tail
// below it keeps the previous order.
const setMessageSort = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageSort: action.payload,
    searchMessages: { offset: 0, limit: 30, paginate: false, scroll: true },
  };
};

/**
 * The filter picks what the right-hand column summarises; it no longer
 * narrows the message stream, so it must not refetch it. Resetting
 * `searchMessages` here used to re-run the query on every pill click, which
 * is what made the centre column visibly change — and threw away the
 * reader's scroll position along with it.
 */
const setMessageFilter = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageFilter: action.payload,
  };
};

// The clicked bucket, kept beside the filter it was derived from. Both the
// pill row and the map column read it, so it cannot live as local state in
// either one of them.
const setMessageBucket = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    messageBucket: action.payload,
  };
};


const getUpdatedLatLng = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    focusLatLng: { ...action.payload },
  };
};

const getFileToSend = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    fileToSend: action.payload,
  };
};

const focusMessage = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    focusMessage: { ...action.payload },
  };
};

const setPageMessages = (state: MessageState, action: any): MessageState => {
  const updatedMessages = state.messages;
  const unProcessedMessages = state.unProcessedMessages;
  const searchMessages = state.searchMessages;
  const { pageId, messages } = action.payload;

  console.log('set messages', messages);

  // debugger;

  let allMessages = [];
  if (searchMessages.paginate) {
    allMessages = [...messages, ...(unProcessedMessages[pageId] || [])];
  } else {
    allMessages = messages;
  }
  allMessages = allMessages.filter((x) => {
    return x.messageType !== "log";
  });

  allMessages.sort((a, b) =>
    a.originalCreatedAt > b.originalCreatedAt
      ? 1
      : b.originalCreatedAt > a.originalCreatedAt
        ? -1
        : 0
  );
  let processedMessages = [];
  let messageMap = {};
  allMessages.map((x) => {
    let id = x.originalCreatedAt;
    if (!messageMap?.[id]) messageMap[id] = [];
    messageMap[id].push(x);
  });
  Object.keys(messageMap).map((i) => {
    if (messageMap?.[i]?.length === 1) {
      const x = messageMap?.[i]?.[0];
      if (
        !x.refMessage ||
        (x.refMessage?.referenceType !== "update" &&
          x.refMessage?.referenceType !== "remove")
      ) {
        processedMessages.push(x);
      }
    } else {
      let orinalPageMessageIdMap = {};
      messageMap?.[i].map((x) => {
        let id = x.originalPageMessageId || x.id;
        if (!orinalPageMessageIdMap?.[id]) orinalPageMessageIdMap[id] = [];
        orinalPageMessageIdMap[id].push(x);
      });
      Object.keys(orinalPageMessageIdMap).map((j) => {
        if (orinalPageMessageIdMap?.[j]?.length === 1) {
          const m = orinalPageMessageIdMap?.[j]?.[0];
          if (
            !m.refMessage ||
            (m.refMessage?.referenceType !== "update" &&
              m.refMessage?.referenceType !== "remove")
          ) {
            processedMessages.push(m);
          }
        } else {
          orinalPageMessageIdMap?.[j].sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : b.createdAt > a.createdAt ? -1 : 0
          );
          const originalMessage = orinalPageMessageIdMap?.[j]?.find((x) => {
            return (
              !x.refMessage ||
              (x.refMessage?.referenceType !== "update" &&
                x.refMessage?.referenceType !== "remove")
            );
          });
          if (
            originalMessage &&
            orinalPageMessageIdMap?.[j]?.[
              orinalPageMessageIdMap?.[j]?.length - 1
            ]?.refMessage?.referenceType === "update"
          ) {
            processedMessages.push(
              orinalPageMessageIdMap?.[j]?.[
              orinalPageMessageIdMap?.[j]?.length - 1
              ]
            );
          }
        }
      });
    }
  });

  let prevMessageCount = updatedMessages[pageId]?.length;
  updatedMessages[pageId] = processedMessages;
  unProcessedMessages[pageId] = allMessages;

  console.log('all messages', processedMessages);

  if (prevMessageCount === processedMessages.length) {
    return {
      ...state,
      NoMessageFound: action.payload,
    };
  }
  else {
    return {
      ...state,
      messages: updatedMessages,
      unProcessedMessages,
    };
  }
};

const getPageMessages = (state: MessageState, action: any): MessageState => {
  const previousSearchMessages = state.searchMessages || {};
  return {
    ...state,
    searchMessages: { ...previousSearchMessages, ...action.payload },
  };
};
const setNOMessageFound = (state: MessageState, action: any): MessageState => {
  return {
    ...state,
    NoMessageFound: action.payload,
  };
};

const messageReducer = (
  state: MessageState = initialState,
  action: any
): MessageState => {
  switch (action.type) {
    case "SET_SELECTED_PAGE_MESSAGE":
      return getSelectedPageMessages(state, action);
    case "SEND_MESSAGE":
      return getMessageToSend(state, action);
    case "SET_MESSAGE_FILTER":
      return setMessageFilter(state, action);
    case "SET_MESSAGE_SORT":
      return setMessageSort(state, action);
    case "SET_MESSAGE_BUCKET":
      return setMessageBucket(state, action);
    case "DELETE_MESSAGE":
      return deleteMessage(state, action);
    case "UPDATE_MESSAGE":
      return updateMessage(state, action);
    case "CLEAR_MESSAGE":
      return clearMessage(state, action);
    case "CHANGE_MAP_FOCUS":
      return getUpdatedLatLng(state, action);
    case "SET_MESSAGES":
      return setPageMessages(state, action);
    case "FOCUS_MESSAGE":
      return focusMessage(state, action);
    case "ADD_FILE":
      return getFileToSend(state, action);
    case "SEARCH_MESSAGES":
      return getPageMessages(state, action);
    case "NO_MESSAGE_FOUND":
      return setNOMessageFound(state, action);
    default:
      return state;
  }
};

export default messageReducer;
